<script>
import PopperWrapper from './PopperWrapper.vue'

export default {
  ...PopperWrapper,
  name: 'VTooltip',
  vPopperTheme: 'tooltip',
}
</script>

<style>
.v-popper--theme-tooltip .v-popper__inner {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  padding: 7px 12px 6px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, .1);
}

.v-popper--theme-tooltip .v-popper__arrow {
  border-color: rgba(255, 255, 255, 0.8);
}
</style>
